export var getAkModalWidth = function getAkModalWidth(modalSize) {
  switch (modalSize) {
    case 'xlarge':
      return 'x-large';
    case 'max':
      return '100%';
    default:
      return modalSize;
  }
};